import { useParams } from 'react-router-dom';
import DeleteContactUsMessageModal from './DeleteContactUsMessageModal';
import ContactUsMessage from './ContactUsMessage';
import useFetchSingleContactUsMessage from './hooks/useFetchSingleContactUsMessage';
import DataCheck from 'lib/src/components/common/DataCheck';
import { isEmpty } from 'lib/src/utils/generic';

const ContactUsMessageContainer: React.FC = () => {
    const { id, action } = useParams<ParamTypes>();
    const { message, isFetching, fetchError } = useFetchSingleContactUsMessage(+id);

    return (
        <>
            <DataCheck dataExists={!isEmpty(message)} isFetching={isFetching} error={fetchError}>
                <ContactUsMessage message={message} />
            </DataCheck>
            {action === 'delete' && <DeleteContactUsMessageModal message={message} />}
        </>
    );
};

interface ParamTypes {
    id: string;
    action: string;
}

export default ContactUsMessageContainer;
